import { SPOTIFY_ACTIVE_PROFILE_ID } from '../constants/storage';
import type { LinkedCuratorProfile } from './accountCuratorOffer';

/** Resolve the Auth0 account user id for the current session (owner when on a shared profile). */
export const getAuthAccountUserId = (): string | null => {
  try {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    const spotifyUser = JSON.parse(localStorage.getItem('spotifyUser') || '{}');
    if (spotifyUser.isShared === true && spotifyUser.ownerId) {
      return spotifyUser.ownerId;
    }
    return userInfo.userId || null;
  } catch {
    return null;
  }
};

export const getActiveProfileObjectId = (): string | null => {
  try {
    const spotifyUser = JSON.parse(localStorage.getItem('spotifyUser') || '{}');
    const fromUser = spotifyUser.profileId ? String(spotifyUser.profileId) : null;
    const fromStorage = localStorage.getItem(SPOTIFY_ACTIVE_PROFILE_ID);
    return fromUser || (fromStorage ? String(fromStorage) : null);
  } catch {
    return null;
  }
};

/** Match the logged-in Spotify profile to a linked account profile row. */
export const resolveActiveProfileId = (
  linkedProfiles: Array<Pick<LinkedCuratorProfile, 'id' | 'username'>> = []
): string | null => {
  const storedId = getActiveProfileObjectId();
  if (storedId && linkedProfiles.some(profile => profile.id === storedId)) {
    return storedId;
  }

  try {
    const spotifyUser = JSON.parse(localStorage.getItem('spotifyUser') || '{}');
    const username = String(spotifyUser?.username || '').trim();
    if (username) {
      const match = linkedProfiles.find(profile => profile.username === username);
      if (match) {
        return match.id;
      }
    }
  } catch {
    // ignore parse errors
  }

  if (linkedProfiles.length === 1) {
    return linkedProfiles[0].id;
  }

  return storedId;
};

/** Pass Mongo profile id to createrequest only when adding via a sibling profile's playlist. */
export const getSiblingProfileObjectIdForAdd = (
  sessionProfileId?: string | null,
  activeProfileId?: string | null
): string | undefined => {
  if (!sessionProfileId) {
    return undefined;
  }
  const resolvedActiveProfileId = activeProfileId ?? getActiveProfileObjectId();
  if (!resolvedActiveProfileId || sessionProfileId === resolvedActiveProfileId) {
    return undefined;
  }
  return sessionProfileId;
};
